import { motion } from 'framer-motion'

export default function ArrowsDownNotifier(props) {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
      },
    },
  }

  const item = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        repeat: Infinity,
        repeatType: 'reverse',
        repeatDelay: 0.5,
      },
    },
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={47} height={62} {...props}>
      <defs>
        <linearGradient
          id="prefix__a"
          x1="0%"
          x2="100%"
          y1="55.339%"
          y2="55.339%"
        >
          <stop offset="0%" stopColor="#00907F" />
          <stop offset="100%" stopColor="#48D59F" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1="0%"
          x2="100%"
          y1="55.339%"
          y2="55.339%"
        >
          <stop offset="0%" stopColor="#00907F" />
          <stop offset="100%" stopColor="#48D59F" />
        </linearGradient>
        <linearGradient
          id="prefix__c"
          x1="0%"
          x2="100%"
          y1="55.339%"
          y2="55.339%"
        >
          <stop offset="0%" stopColor="#00907F" />
          <stop offset="100%" stopColor="#48D59F" />
        </linearGradient>
      </defs>
      <motion.g
        fill="none"
        fillRule="evenodd"
        strokeWidth={2}
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.path
          stroke="url(#prefix__a)"
          opacity={0.12}
          transform="rotate(90 22.625 8.875)"
          d="M14.554-7L29.5 7.884 14.5 23"
          variants={item}
        />
        <motion.path
          stroke="url(#prefix__b)"
          opacity={0.35}
          transform="rotate(90 22.625 28.875)"
          d="M12.568 9L31.5 27.854 12.5 47"
          variants={item}
        />
        <motion.path
          stroke="url(#prefix__c)"
          transform="rotate(90 22.625 49.375)"
          d="M11.079 26.5L33 48.331 11 70.5"
          variants={item}
        />
      </motion.g>
    </svg>
  )
}
